import React, { useRef } from 'react';

import { getApplicableL2MyDataModules } from 'Deer/components/navigation/secondary/ModuleSection';
import { ReviewsIntentLandingPage } from 'Deer/intent/Reviews/ReviewsIntentLandingPage';
import { IntentDropdown } from 'Deer/intent/Reviews/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { ReviewAudit } from 'screens/performanceReview/LandingPage';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';

const ReviewsExplore = () => {
  const gridRef = useRef();
  const { moduleName } = useOrganisationSettings();

  const applicableL2MyDataModules = getApplicableL2MyDataModules(moduleName) ?? [];

  if (isMobileView() || !checkIntentLandingPagesFeatureEnabled()) {
    return <ReviewAudit />;
  }

  return (
    <Layout
      Filters={
        <IntentDropdown
          gridRef={gridRef}
          breadcrumbs={{
            items: [
              {
                label: 'Me',
                to: applicableL2MyDataModules[0]?.value,
              },
            ],
            page: {
              label: 'Reviews',
              to: '',
            },
          }}
        />
      }
    >
      <ReviewsIntentLandingPage gridRef={gridRef} />
    </Layout>
  );
};

export default ReviewsExplore;
